import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Plant from '../assets/icons/custom/plant.svg?react';

export function PlantIcon(props: SvgIconProps) {
  return <SvgIcon component={Plant} inheritViewBox {...props} />;
}
